<template>
  <UiConfirm
    ref="confirm"
    :width="480"
    :action-name="!monitoringInfo ? $t('affiliates.monitored.actionStart') : $t('affiliates.confirm.save')"
    action=""
    action-fa-icon="check"
    :action-disabled="v$.$invalid"
    class="start-monitoring"
    @close="confirmClose"
    @save="handleStartMonitoredClick"
  >
    <template v-slot:title>
      <div>
        {{ monitoringInfo ? $t('affiliates.monitored.monitoringPopup.title_edit', {affiliateEmail: monitoringInfo.affiliate_email}) : $t('affiliates.monitored.monitoringPopup.title_new') }}
      </div>
    </template>
    <div class="body__wrap">
      <div class="start-monitoring__reason">
        <UiTextarea
          v-model="reason"
          :label="$t('affiliates.monitored.reason')"
          :rows="3"
          :placeholder="$t('affiliates.monitored.monitoringPopup.placeholder')"
          resize="vertical"
          :error="errors.reason"
        />
      </div>
      <div class="start-monitoring__notify">
        <div class="t:flex t:items-center t:mb-8 t:space-x-4">
          <div class="start-monitoring__title">
            {{ $t('affiliates.monitored.notify') }}
          </div>
          <UiSwitch
            v-model="isNotify"
          />
        </div>
        <UiDatePicker
          v-model="date"
          :placeholder="$t(`team_popup.see_stats_placeholder`)"
          :multi-calendars="false"
          :range="false"
          :always-clearable="false"
          :disabled="!isNotify"
          external-format="dd MMM yyyy HH:mm"
          enable-time-picker
          is-value-required
          size="big"
          teleport
        />
      </div>
    </div>
  </UiConfirm>
</template>

<script>
import { format } from 'date-fns';
import { required, requiredIf } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import errorHandleMixin from '@/views/mixins/error-hadle';
import validateMixin from '@/components/Popups/mixin/validate';
export default {
  name: 'MonitoringPopup',
  props: {
    affiliateId: {
      type: String,
      default: () => '',
    },
    monitoringInfo: {
      type: [Object, null],
      default: () => null,
    },
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
  setup: () => ({ v$: useVuelidate() }),
  mixins: [errorHandleMixin, validateMixin],
  emits: ['close', 'update:monitoring-info'],
  data() {
    return {
      errors: {},
      reason: '',
      date: '',
      isNotify: false,
    };
  },

  validations() {
    return {
      reason: {
        required,
      },
      date: {
        required: requiredIf(() => this.isNotify),
      },
    };
  },

  watch: {
    isOpen(v) {
      if (v) {
        this.reason = this.monitoringInfo?.reason ?? '';
        this.date = this.monitoringInfo?.expires_at ?? '';

        if(this.date !== '') this.isNotify = true;
        this.$refs.confirm.open();
      }
    },
  },

  mounted() {
    window.addEventListener('keyup', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.$emit('close');
      }
    });
  },

  methods: {
    confirmClose() {
      this.errors = {};
      this.$emit('close');
    },
   async handleStartMonitoredClick() {
      this.errors = {};
      const params = {
        reason: this.reason,
      };
      if (!this.monitoringInfo) {
        params.affiliate_id = this.affiliateId;
      }
      if (this.isNotify) {
        params.expires_at = format(this.date, 'yyyy-MM-dd HH:mm:ss');
      }
      try {
        const response = this.monitoringInfo
          ? await this.$api.putAffiliateMonitoring(this.monitoringInfo.id, params)
          : await this.$api.postAffiliateMonitoring(params);

        this.$emit('update:monitoring-info', response.data.payload);
        this.$refs.confirm.close();
      } catch (error) {
        this.errors = this.$_.cloneDeepWith(error.data.errors);
      }
    },
  },
};
</script>

<style lang="scss">
.start-monitoring {
  &.ui-confirm {
    .head{
      .title{
        span{
          white-space: nowrap;
        }
      }
    }
    .wrapper {
      .body__wrap{
        display: block;
        .error .el-textarea__inner{
          border-color: var(--text-negative);
        }
      }
    }

  }
  &__title {
    font-size: 14px;
    color: #212529;
  }
  &__reason {
    margin-bottom: 16px;
  }

}
</style>
